import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICerere } from '../../cereri.interface';
import { CereriService } from '../../cereri.service';
import { AppFilesService } from 'src/app/services/app-files.service';

@Component({
    selector: 'app-documente-cerere',
    templateUrl: './documente-cerere.component.html',
    styleUrls: ['./documente-cerere.component.scss']
})
export class DocumenteCerereComponent {
    @Input() cerere!: ICerere;
    @Output() isLoading = new EventEmitter<boolean>();

    constructor(
        private cereriService: CereriService,
        private appFileService: AppFilesService,
    ) { }

    getDocumentTypeKeys(): string[] {
        return this.cerere ? Object.keys(this.cerere.documente) : [];
    }

    getDocumentKeys(docTypeKey: string): string[] {
        return this.cerere
            ? Object.keys(this.cerere.documente[docTypeKey].documente)
            : [];
    }

    downloadDocument(file: any) {
        let fullPath = this.cereriService.downloadDocumentUrl + file.id;
        this.isLoading.emit(true);
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading.emit(false);
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading.emit(false);
            })
    }
}
